module.exports = __webpack_public_path__ + "static/john-smile-7d6705cb91c0e4a3e5a869e550eb8234.gif";